<template>
  <div>
    <h2>{{ mode }} Records</h2>

    <div class="row">
      <div class="col-sm"></div>
      <div class="col-6">
        <!-- <div class="alert alert-danger" role="alert">{{ error }}</div> -->
        <div v-if="errorMessage" class="alert alert-danger" role="alert">
          <h4 class="alert-heading">{{ errorCode }}</h4>
          <p>{{ errorMessage }}</p>
        </div>

        <form>
          <div v-if="mode === 'update'" class="form-group">
            <label for="axis_id">ID</label>
            <p>{{ id }}</p>
          </div>

          <div class="form-group">
            <label for="axis_type">Category</label>
            <select class="form-control" id="axis_category" v-model="category">
              <option>people</option>
              <option>organization</option>
            </select>
          </div>
          <div class="form-group">
            <label for="axisName">Name</label>
            <input
              v-model="name"
              type="text"
              class="form-control"
              id="axisName"
              placeholder="Enter Name"
            >
            <small id="axisNameHelp" class="form-text text-muted">名前を入力してください。</small>
          </div>

          <div class="form-row">
            <div class="col">
              <label for="axisName">Start</label>
              <input v-model="start" class="form-control" type="number">
            </div>
            <div class="col">
              <label for="axisName">End</label>
              <input v-model="end" class="form-control" type="number">
            </div>
          </div>

          <br>

          <div class="form-group">
            <label for="exampleFormControlFile1">Image</label>
            <br>

            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" value="url" v-model="imageUploadType">
              <label class="form-check-label" for="inlineRadio1">URL</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" value="upload" v-model="imageUploadType">
              <label class="form-check-label" for="inlineRadio2">アップロード</label>
            </div>

            <br>

            <input
              v-if="!imageUpload"
              v-model="imageUrl"
              type="text"
              class="form-control"
              placeholder="https://picsum.photos/200/300/?random"
            >
            <br>
            <input
              v-if="imageUpload"
              type="file"
              class="form-control-file"
              id="exampleFormControlFile1"
            >
          </div>

          <div class="form-group">
            <img v-bind:src="imageUrl" width="30%">
          </div>

          <br>

          <div class="form-group">
            <div class="row">
              <div class="col-1">
                <label for="axisName">Events</label>
              </div>
              <div class="col">
                <button @click="addEvent" class="btn btn-sm btn-primary">+</button>
              </div>
            </div>

            <table class="table">
              <thead>
                <tr>
                  <td></td>
                  <td>Started At</td>
                  <td>Content</td>
                  <td></td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="event in events" v-bind:key="event.id">
                  <td>{{ event.id }}</td>
                  <td>
                    <input
                      v-model="event.start"
                      type="number"
                      class="form-control"
                      placeholder="Started"
                    >
                  </td>
                  <td>
                    <input
                      v-model="event.content"
                      type="text"
                      class="form-control"
                      placeholder="Content"
                    >
                  </td>
                  <td>
                    <button @click="addEvent" class="btn btn-sm btn-primary">+</button>
                  </td>
                  <td>
                    <button @click="removeEvent(event.id)" class="btn btn-sm btn-danger">-</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <button @click="onSubmit" class="btn btn-primary">Save</button>
        </form>
      </div>
      <div class="col-sm"></div>
    </div>
  </div>
</template>

<script>
import { API } from "aws-amplify";
import uuid from "uuid";
import { mapActions } from "vuex";

export default {
  name: "edit",
  data: function() {
    return {
      id: "",
      category: "",
      name: "",
      start: null,
      end: null,
      imageUrl: "",
      events: [],
      imageUploadType: "url", // url or upload
      errorCode: "",
      errorMessage: "",
      mode: "create", // or update
      response: null
    };
  },
  computed: {
    imageUpload: function() {
      return this.imageUploadType === "upload";
    }
  },
  created: function() {
    if (
      this.$route.name === "edit_records" &&
      this.$route &&
      this.$route.params &&
      this.$route.params.record
    ) {
      this.mode = "update";

      this.id = this.$route.params.record.id;
      this.category = this.$route.params.record.category;
      this.name = this.$route.params.record.name;
      this.start = this.$route.params.record.start;
      this.end = this.$route.params.record.end;
      this.imageUrl = this.$route.params.record.imageUrl;
      this.events = this.$route.params.record.events;
      this.imageUploadType = this.$route.params.record.imageUploadType;
    } else {
      this.mode = "create";

      this.$router.push({ name: "new_records" });
    }
  },
  methods: {
    addEvent: function() {
      this.events.push({ id: this.events.length + 1 });
    },
    removeEvent: function(eventId) {
      const index = this.events.findIndex(row => {
        return row.id === eventId;
      });
      if (index > -1) {
        this.events.splice(index, 1);
      }
    },
    onSubmit: async function() {
      let params = {
        body: {
          category: this.category,
          name: this.name,
          createdAt: new Date().toDateString()
        }
      };

      params.body.id = this.mode === "create" ? uuid() : this._data.id;

      if (this.start) {
        params.body.start = Number(this.start);
      }
      if (this.end) {
        params.body.end = Number(this.end);
      }
      if (this.imageUrl) {
        params.body.imageUrl = this.imageUrl;
      }
      if (this.events && this.events.length > 0) {
        params.body.events = this.events.map(v => {
          v["start"] = Number(v["start"]);
          return v;
        });

        console.log("params.body", params.body);
      } else {
        params.body.events = [];
      }

      const ret =
        this.mode === "create"
          ? await this.postRecord(params)
          : await this.putRecord(params);

      if (ret.error) {
        this.errorCode = ret.error.code;
        this.errorMessage = ret.error.message;
      } else {
        this.$router.push({ name: "records" });
      }
    },
    ...mapActions(["postRecord", "putRecord"])
  }
};
</script>